import React from 'react';

interface IProps {
  x0: number;
  y0: number;
  width: number;
  height: number;
  color: string;
}

export default (props: IProps) => {
  const {x0, y0, width, height, color} = props;
  return (
    <rect
      fill={color}
      strokeWidth={1}
      stroke='white'
      x={x0} y={y0} width={width} height={height}
      vectorEffect='non-scaling-stroke'/>
  );
};
